import { Injectable, inject } from '@angular/core';
import type { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

import { RbacPermissionsHttpService } from './rbac-permissions.http.service';
import { RbacPermissionsService } from './rbac-permissions.service';

import AppActions from '@web/store/app/app.actions';
import RbacPermissionsActions from './rbac-permissions.actions';
import { AppFacade } from '@web/store/app/app.facade';

@Injectable()
export class RbacPermissionsEffects {
    private readonly actions$ = inject(Actions);
    private readonly appFacade = inject(AppFacade);
    private readonly rbacPermissionsHttpService = inject(RbacPermissionsHttpService);
    private readonly rbacPermissionsService = inject(RbacPermissionsService);

    public readonly loadRbacPermissions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.initApp),
            concatLatestFrom(() => this.appFacade.isAdmin$),
            filter(([, isAdmin]) => !isAdmin),
            switchMap(() => {
                return this.rbacPermissionsHttpService.getPermissions().pipe(
                    map((res) => res),
                    catchError((error: HttpErrorResponse) => {
                        if (error.status === 203) {
                            return of({
                                tariffs: false,
                                sites: false,
                                pages: false,
                                siteIds: [],
                            });
                        }

                        return of(null);
                    })
                );
            }),
            switchMap((permissions) => {
                if (!permissions) {
                    return [];
                }

                return [
                    RbacPermissionsActions.loadRbacPermissionsSuccess({
                        permissions: this.rbacPermissionsService.proceedUserPermissions(permissions),
                    }),
                ];
            })
        )
    );
}
